import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import { ariaLabel, PREVIOUS_PAGE } from "src/constants";
import { useDeviceWidth } from "src/hooks";

export const BackToDocumentsButton = () => {
  const navigate = useNavigate();
  const { isMobile } = useDeviceWidth();
  return (
    <Button
      variant="contained"
      onClick={() => navigate(PREVIOUS_PAGE)}
      role="link"
      aria-label={ariaLabel.documentsGoBackButtonLabel}
    >
      {isMobile ? <ArrowBackIcon /> : ariaLabel.documentsGoBackButtonLabel}
    </Button>
  );
};
